/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { UserManagerSettings } from "oidc-client";
import { runtimeEnv } from "../configuration";
import { joinUrl } from "./helpers";

export const IDENTITY_CONFIG: UserManagerSettings = {
  authority: runtimeEnv.REACT_APP_AUTH_URL,
  client_id: runtimeEnv.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: joinUrl(runtimeEnv.REACT_APP_SANDBOXURL, runtimeEnv.REACT_APP_BASEURL, runtimeEnv.REACT_APP_REDIRECT_URL),
  silent_redirect_uri: joinUrl(runtimeEnv.REACT_APP_SANDBOXURL, runtimeEnv.REACT_APP_BASEURL, runtimeEnv.REACT_APP_SILENT_REDIRECT_URL),
  post_logout_redirect_uri: joinUrl(runtimeEnv.REACT_APP_SANDBOXURL, runtimeEnv.REACT_APP_BASEURL, runtimeEnv.REACT_APP_LOGOFF_REDIRECT_URL),
  automaticSilentRenew: false,
  response_type: "code",
  scope: runtimeEnv.REACT_APP_SCOPE,
};
